module.exports = __webpack_public_path__ + "img/kingr.2b52521d.jpg";